module.exports = __webpack_public_path__ + "static/arrow-heart-circle-04a3013198124f88fa103ab9aa35ce7a.svg";